export function utilsCreateTemporaryLinkToDownload(name, data, type = 'application/pdf', extension = 'pdf') {
  const urlFile = URL.createObjectURL(new Blob([data], {type: type}))
  const aElement = document.createElement("a")
  aElement.href = urlFile
  document.body.appendChild(aElement)
  aElement.download = extension == 'octet-stream' ? `${name}.pdf` : `${name}.${extension}`
  aElement.click()
  aElement.remove()
}

export function utilsTestTypeAttribute(name, value, type) {
  const expection = new TypeError(
    `Attribute "${name}:${value}" must be "${type}"`)

  switch (type) {
    case 'array':
      if (!Array.isArray(value)) {
        throw expection
      }
      break;
    case 'object':
      if (Array.isArray(value)) {
        throw expection
      }
      break;
    case 'null':
      if (value.toString() !== type) {
        throw expection
      }
      break;
    default:
      //primitive type
      if (typeof value !== type) {
        throw expection
      }
      break;
  }
}

export function utilsShowErrorInDevelopmentEnvironment(error) {
  if (process.env.NODE_ENV === 'development') {
    console.error(error)
  }
}

export function resetForm(instanceVue, name) {
  instanceVue.$refs[name].reset()
}

export function resetFormFields(instanceVue, fields) {
  fields.forEach((elem) => {
    instanceVue.$refs[elem].reset();
  });
}

export function utilsTranformValueToOnlyNumber(value) {
  if(value == undefined || value == null){
    throw "value cannot be undefined or null"
  }
  return String(value).replace(/\D/g, '')
}

export function utilsTranformValueToAlphanumeric(value) {
  if(value == undefined || value == null){
    throw "value cannot be undefined or null"
  }
  return String(value).replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
}

export function utilsIsValidLength(value, length) {
  return !!value && value.length === length
}

export function getUfs() {
  return [
    {id: "AC", name: "Acre"},
    {id: "AL", name: "Alagoas"},
    {id: "AM", name: "Amazonas"},
    {id: "AP", name: "Amapá"},
    {id: "BA", name: "Bahia"},
    {id: "CE", name: "Ceará"},
    {id: "DF", name: "Distrito Federal"},
    {id: "ES", name: "Espírito Santo"},
    {id: "GO", name: "Goiás"},
    {id: "MA", name: "Maranhão"},
    {id: "MG", name: "Minas Gerais"},
    {id: "MS", name: "Mato Grosso do Sul"},
    {id: "MT", name: "Mato Grosso"},
    {id: "PA", name: "Pará"},
    {id: "PB", name: "Paraíba"},
    {id: "PE", name: "Pernambuco"},
    {id: "PI", name: "Piauí"},
    {id: "PR", name: "Paraná"},
    {id: "RJ", name: "Rio de Janeiro"},
    {id: "RN", name: "Rio Grande do Norte"},
    {id: "RO", name: "Rondônia"},
    {id: "RR", name: "Roraima"},
    {id: "RS", name: "Rio Grande do Sul"},
    {id: "SC", name: "Santa Catarina"},
    {id: "SE", name: "Sergipe"},
    {id: "SP", name: "São Paulo"},
    {id: "TO", name: "Tocantins"}
  ]
}

export function createDebounce(fn, time) {
  let setTimeoutId

  return function() {
    clearTimeout(setTimeoutId)
    setTimeoutId = setTimeout(() => {
      fn.apply(this, arguments)
    }, time)
  }
}

export function getLocalIsoString() {
  const minutesOfDifference = new Date().getTimezoneOffset()
  const milleSecondsForDecrement = 60000 * minutesOfDifference
  const currentTimeInMilleSeconds = new Date().getTime()

  return new Date(currentTimeInMilleSeconds - milleSecondsForDecrement).toISOString()
}

export function transformToKebabCase (text='', separator=' ')  {
  try {
      const separators = [' ', 'regExp:camelCase', 'regExp:snakeCase']
      const groupOfRegExp = {
          camelCase: {
            regExp: /(?=[a-z])*([A-Z])/g,
            callback: (match) => {
              return `-${match.toLowerCase()}`;
            }
          },
          snakeCase: {
            regExp: /\B(?:[_])\B/g,
            callback: (match) => {
              return '-';
            }
          }
      }

      if (typeof text !== 'string') {
          throw new TypeError(`transformToKebabCase: param text must be string. got it ${typeof text}.`)
      }

      if (separators.indexOf(separator) === -1) {
          throw new Error(`transformToKebabCase: invalid param separator value '${separator}'. valid separetors: ${separators}.`)
      }

      if (separator.indexOf('regExp') !== -1) {
          const key = separator.split(':')[1]
          const regExp = groupOfRegExp[key].regExp
          const callback = groupOfRegExp[key].callback

          return text.replace(regExp, callback)
      } else {
          return text.toLowerCase().split(' ').join('-')
      }
  } catch (error) {
      throw error
  }
}
